import { MAP_EDIT_BUCKETS } from 'src/components/pages/retail/trip/TripManagerMapEdit/TripManagerMapEditKeys';
import {
  getPlannedTripTrackingData,
  getRiderTripData,
} from 'src/api/trips';
import {
  getAllConsignmentsData,
  updateUserTripColumnList,
} from 'src/api/genericConsignmentView';

const viewControl = {
  pageTitle: 'Edit',
  buckets: [MAP_EDIT_BUCKETS.MAP_TRIPS, MAP_EDIT_BUCKETS.DRIVERS, MAP_EDIT_BUCKETS.MAP_UNPLANNED],
  navBar: {
    left: ['date_filter'],
    right: [],
  },
  globalActions: [],
  dateFilterOptions: [
    { key: 'created_at', val: 'Created At' },
    { key: 'last_main_event_time', val: 'Last Updated' },
  ],
};

const buckets = {
  [MAP_EDIT_BUCKETS.MAP_TRIPS]: {
    hidePagination: true,
    hidePerPageCount: true,
    name: 'Trips',
    filters: ['planning_id', 'status', 'trip_type', 'vehicleType', 'worker_id'],
    actions: [],
    isSubBucket: false,
    fetchData: getPlannedTripTrackingData,
    updateUserColumnList: updateUserTripColumnList,
  },
  [MAP_EDIT_BUCKETS.DRIVERS]: {
    hidePagination: true,
    hidePerPageCount: true,
    name: 'Drivers',
    filters: [],
    actions: [],
    isSubBucket: false,
    fetchData: getRiderTripData,
  },
  [MAP_EDIT_BUCKETS.MAP_UNPLANNED]: {
    hidePagination: true,
    hidePerPageCount: true,
    name: 'Unplanned Tasks',
    filters: ['service_type', 'consignment_type', 'customer_code'],
    actions: [],
    isSubBucket: false,
    fetchData: getAllConsignmentsData,
  },
};

const bucketColor = {
  map_trips: '#EB2F96',
  map_unplanned: '#722ED1',
};

export default { viewControl, buckets, bucketColor };
